import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3;
import { jsxs, jsx } from 'react/jsx-runtime';
import { Text, theme } from '@dls/web';
import styled from 'styled-components';
import Anchor from '../../../Anchor/index.js';
import { remCalc } from '../../../../helpers/styles.js';
import '@geit/ui-components';
const LogoAnchor = styled(Anchor)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  margin-left: 8px;\n  margin-right: 8px;\n"])));
const LogoImg = styled.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: ", ";\n  margin-top: -8px;\n  margin-right: 13px;\n"])), remCalc(64));
const LogoText = styled(Text)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 16px;\n"])));
const Logo = _ref => {
  let {
    baseUrl,
    link,
    alt,
    src,
    onClick,
    showAlt = false
  } = _ref;
  return /* @__PURE__ */jsxs(LogoAnchor, {
    href: "".concat(baseUrl).concat(link),
    ariaLabel: "Logo",
    onClick,
    children: [/* @__PURE__ */jsx(LogoImg, {
      src,
      alt,
      title: alt
    }), showAlt && /* @__PURE__ */jsx(LogoText, {
      type: "bannerTitle",
      fontWeight: "bold",
      color: theme.main.colours.white,
      children: alt
    })]
  });
};
export { Logo as default };